// ─── Helpers ────────────────────────────────────────────────────────────────

function hideAll(selector, root) {
  (root || document).querySelectorAll(selector).forEach(function (el) {
    el.style.display = 'none';
  });
}

// ─── Pledge Donation: refresh cart drawer HTML via fetch ────────────────────

addEventListener('PledgeDonationChanged', function () {
  fetch('/?section_id=cart-drawer')
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var newInner = parsed.querySelector('cart-drawer');
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (newInner && cartDrawerEl) {
        cartDrawerEl.innerHTML = newInner.innerHTML;
      }
      document.querySelectorAll('.cart-item__name').forEach(function (el) {
        var itemId = el.getAttribute('data-item-id');
        if (Number(itemId) === 8075999543427) {
          hideAll('.main_gift_box');
        }
      });
    });
});

// ─── Cart Upsell + Gift logic ────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', function () {

  function cartUpsell() {
    var nameEl = document.querySelector('.cart-item__name');
    var itemId = nameEl ? nameEl.getAttribute('data-item-id') : null;

    document.querySelectorAll('.card_relatedslide_block .swiper-slide, .main_gift_box').forEach(function (el) {
      var upsellId = el.getAttribute('data-upsell-id');
      if (upsellId && upsellId === itemId) {
        el.style.display = 'none';
      }
      if (itemId === '8493242286211') {
        hideAll('.ctm_yml_head');
      }
    });
  }

  function cartGift() {
    document.querySelectorAll('.main_gift_box').forEach(function (giftBox) {
      var giftId = giftBox.getAttribute('data-gift-id');

      document.querySelectorAll('.cart-item__name').forEach(function (nameEl) {
        var itemId = nameEl.dataset.itemId || nameEl.getAttribute('data-item-id');
        if (Number(itemId) === 8075999543427) {
          hideAll('.main_gift_box');
        }
      });

      if (Boolean(window.localStorage.getItem('gift_card_removed'))) {
        giftBox.remove();
        return;
      }

      document.querySelectorAll('.cart-item__name').forEach(function (nameEl) {
        var itemId = nameEl.getAttribute('data-item-id');
        if (itemId === giftId) {
          giftBox.remove();
          window.localStorage.setItem('gift_card_removed', true);
        }
      });
    });
  }

  window.localStorage.removeItem('gift_card_removed');
  cartUpsell();
  cartGift();

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    setTimeout(function () {
      cartUpsell();
      cartGift();
    }, 100);
  });
});

// ─── Upsell close: delegated once at document level ─────────────────────────

document.addEventListener('click', function (e) {
  if (e.target.closest('.upsell_close')) {
    setTimeout(function () {
      hideAll('.ctm_cart, .main_gift_box');
    }, 100);
  }
});

// ─── CartDrawer custom element ───────────────────────────────────────────────

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => { this.classList.add('animate', 'active'); });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
